const benefits = [
  {
    icon: 'ri-timer-line',
    title: 'Save Time',
    description: 'Pre-built templates and automated calculations eliminate manual data entry, freeing hours each week for strategic work that grows your business.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Reduce Manual Work',
    description: 'Automated formulas, smart fill features, and batch operations minimize repetitive tasks so you can focus on analysis rather than data input.',
  },
  {
    icon: 'ri-check-double-line',
    title: 'Improve Data Accuracy',
    description: 'Built-in validation rules, error checking, and consistent formatting ensure your spreadsheet data remains reliable and trustworthy.',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Manage Business Better',
    description: 'Centralize business operations — from inventory to finances — in one organized spreadsheet system designed for real-world business needs.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide mb-4">
            Why Vigorbuy
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
            Why Choose Vigorbuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            Businesses worldwide trust Vigorbuy Spreadsheet for its reliability, ease of use, and comprehensive feature set.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((benefit) => (
            <div key={benefit.title} className="text-center group">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${benefit.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{benefit.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}